import React from 'react';
import PropTypes from 'prop-types';
import { SectionWrapper } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { resolveRenderField } from '../../../../../services/cms/HtmlResolver';

export const BoosterCareSection = ({ boosterCareContent, dynamicValue, dropdownField, forceExpand, cmsTags }) => {
  return (
    <div className="boosterCareSection">
      <SectionWrapper
        key="boosterCare"
        customCssClass="accordionButtonClass"
        headerButtonCustomLabel="Booster care"
        isOpen={forceExpand || false}
      >
        {boosterCareContent?.map(({ fullKey, field }) => (
          <React.Fragment key={fullKey}>
            {resolveRenderField({ field, key: fullKey, dynamicValue, dropdownField, cmsTags })}
          </React.Fragment>
        ))}
      </SectionWrapper>
    </div>
  );
};

BoosterCareSection.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  boosterCareContent: PropTypes.array,
  dynamicValue: PropTypes.object,
  dropdownField: PropTypes.object,
  forceExpand: PropTypes.bool,
  cmsTags: PropTypes.object
  /* eslint-disable react/forbid-prop-types */
};
